module.exports = "/images/kw.svg?2f620ff3c548e0da0b536fa8251fce19";